export const VIRTUAL_ROOT_ID = 'VIRTUAL_ROOT_ID';
export const VIRTUAL_LOCAL_ROOT_ID = 'VIRTUAL_LOCAL_ROOT_ID';
